import { useEffect, useState } from "react";
import type { BuilderSelection } from "@keydials/dial-workspace";
import { builderCopy as copy } from "./copy";
import type { ReadinessView } from "./readiness";

const LIST_ID = "kd-readiness-list";

/**
 * The readiness pill on the Build and Details stages (KEY-560): how many things stand between this dial and going live, as the
 * server counts them. Pressing it lists them, and a problem on a section, an action point or a field has "Fix this", which shows it.
 */
export function ReadinessPill({ view, onJump }: { view: ReadinessView; onJump: (selection: BuilderSelection) => void }) {
  const [open, setOpen] = useState(false);

  // Once everything's fixed the list goes, and it stays shut if a later edit brings a problem back.
  useEffect(() => {
    if (view.ready) setOpen(false);
  }, [view.ready]);

  if (view.ready) {
    return (
      <span className="kd-readiness-pill" data-ready="true">
        <span className="kd-readiness-dot" aria-hidden="true" />
        {view.label}
      </span>
    );
  }

  const lines = [...view.jumpable, ...view.general];
  return (
    <div className="kd-readiness">
      <button type="button" className="kd-readiness-pill" aria-expanded={open} aria-controls={LIST_ID} onClick={() => setOpen((was) => !was)}>
        <span className="kd-readiness-dot" aria-hidden="true" />
        {view.label}
      </button>
      {open && (
        <div id={LIST_ID} className="kd-readiness-list">
          <h2 className="kd-panel-heading">{copy.launch.checklistHeading}</h2>
          <ul>
            {lines.map((line) => (
              <li key={line.id}>
                <span>{line.sentence}</span>
                {line.jump && (
                  <button
                    type="button"
                    className="kd-builder-link"
                    onClick={() => {
                      if (line.jump) onJump(line.jump);
                      setOpen(false);
                    }}
                  >
                    {copy.launch.fixThis}
                  </button>
                )}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
